"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationDetailsClasses = exports.LocationItem = void 0;
// istanbul ignore file: doesn't hold any logic
const LocationDetails_1 = __importDefault(require("./LocationDetails"));
var LocationDetails_2 = require("./LocationDetails");
Object.defineProperty(exports, "LocationItem", { enumerable: true, get: function () { return LocationDetails_2.LocationItem; } });
var styles_1 = require("./styles");
Object.defineProperty(exports, "LocationDetailsClasses", { enumerable: true, get: function () { return styles_1.classes; } });
exports.default = LocationDetails_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbG9jYXRpb24tZGV0YWlscy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSwrQ0FBK0M7QUFDL0Msd0VBQWdEO0FBR2hELHFEQUFpRDtBQUF4QywrR0FBQSxZQUFZLE9BQUE7QUFFckIsbUNBQTZEO0FBQXBELGdIQUFBLE9BQU8sT0FBMEI7QUFFMUMsa0JBQWUseUJBQWUsQ0FBQyJ9